import { Plus } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const ShelfCard = ({ shelf, onClick, index, highlight }) => {
  const { t } = useI18n();
  const car = shelf.car;
  const tone = car
    ? "bg-rose-50 border-rose-300 hover:bg-rose-100 text-rose-950"
    : "bg-emerald-50 border-emerald-300 hover:bg-emerald-100 text-emerald-950";
  return (
    <button onClick={onClick} id={`shelf-${shelf.number}`} data-testid={`shelf-card-${shelf.number}`} data-status={car ? "occupied" : "available"} data-highlight={highlight ? "true" : "false"}
      style={{ animationDelay: `${Math.min(index, 40) * 15}ms` }}
      className={`rise text-start border-2 rounded-lg p-3 min-h-[120px] flex flex-col transition-[background-color,transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-md ${tone} ${highlight ? "ring-4 ring-sky-500 ring-offset-2 scale-105 shadow-lg z-10" : ""}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold opacity-70">{t("shelf")}</span>
        <span className={`w-2 h-2 rounded-full ${car ? "bg-rose-500" : "bg-emerald-500"}`} />
      </div>
      <div className="text-3xl font-black leading-none mt-1">{shelf.number}</div>
      {car ? (
        <div className="mt-auto pt-2 space-y-1">
          <span className="plate text-xs" data-testid={`shelf-plate-${shelf.number}`}>{car.plate_number}</span>
          <div className="text-xs truncate opacity-80">{car.car_type}</div>
        </div>
      ) : (
        <div className="mt-auto pt-2 text-xs flex items-center gap-1 opacity-70"><Plus className="w-3 h-3" />{t("available")}</div>
      )}
    </button>
  );
};
